import SearchFilterComponent from "./SearchFilterComponent";

export default SearchFilterComponent;